import React, { Component } from "react";
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { GetConfiguration } from '../../helpers/helper-functions';


type Props = {
    isActive: boolean,
    onError: any
}

type State = {
    initialized: boolean,
    hasError: boolean,
    appInsightsInstrumentationKey: string
}

let reactPlugin: any = null;
let appInsights: any = null;

const createTelemetryService = (isActive: boolean) => {

    const initialize = (instrumentationKey: string) => {

        if (!instrumentationKey) {
            throw new Error('Instrumentation key not provided.')
        }

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin],
                isCookieUseDisabled: isActive
            }
        });

        if (isActive) {
            appInsights.loadAppInsights();
            appInsights.trackPageView();
        }
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = (isActive: boolean) => createTelemetryService(isActive);
export const getAppInsights = () => appInsights;

class AppInsightsErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false, initialized: false, appInsightsInstrumentationKey: "" }
        this.initializeApplicationInsights();
    }

    async initializeApplicationInsights() {
        var configuration = await GetConfiguration();

        const { initialized } = this.state;
        this.state = { ...this.state, appInsightsInstrumentationKey: configuration.appinsights_Instrumentationkey }

        if (!initialized && this.state.appInsightsInstrumentationKey) {
            ai(this.props.isActive).initialize(this.state.appInsightsInstrumentationKey);
            this.setState({ initialized: true });
        }
    }

    async componentDidCatch(error: any, errorInfo: any) {
        this.setState({ hasError: true })
        if (this.props.isActive && this.state.initialized) {
            getAppInsights().appInsights.trackException({
                error,
                exception: error,
                severityLevel: SeverityLevel.Error,
                properties: { ...errorInfo },
            })
        }
    }

    render() {
        if (this.state.hasError) {
            const ErrorHandleElement = this.props.onError;
            return <ErrorHandleElement></ErrorHandleElement>;
        }

        return this.props.children;
    }
}

export default AppInsightsErrorBoundary